<button
  type="button"
  class="ks-icon-btn topbar__burger"
  aria-label="Abrir el menú de navegación"
  (click)="menuToggle.emit()">
  <i class="bi bi-list" aria-hidden="true"></i>
</button>

<span class="crumb-icon" aria-hidden="true"><i class="bi bi-{{ crumb().icon }}"></i></span>
<h1 class="crumb-title">{{ crumb().title }}</h1>

<span class="topbar__spacer"></span>

<app-theme-toggle />

<div class="profile">
  <button
    type="button"
    class="profile__trigger"
    aria-haspopup="menu"
    [attr.aria-expanded]="profileOpen()"
    [attr.aria-label]="'Cuenta de ' + (user()?.fullName || 'usuario')"
    (click)="toggleProfile()">
    <span class="profile__avatar" aria-hidden="true">{{ initials() }}</span>
    <span class="profile__name">{{ user()?.fullName || 'Mi cuenta' }}</span>
    <i class="bi bi-chevron-down profile__caret" [class.is-open]="profileOpen()" aria-hidden="true"></i>
  </button>

  @if (profileOpen()) {
    <div class="profile__menu" role="menu">
      <div class="profile__head">
        <span class="profile__avatar profile__avatar--lg" aria-hidden="true">{{ initials() }}</span>
        <span class="profile__id">
          <span class="profile__id-name">{{ user()?.fullName || 'Sin nombre' }}</span>
          <span class="profile__id-mail">{{ user()?.email }}</span>
        </span>
      </div>

      @if (user(); as current) {
        <div class="profile__meta">
          <span class="ks-badge ks-badge--info">{{ current.profile }}</span>
          @if (current.lastLoginAt) {
            <span class="profile__meta-text">
              Último acceso: {{ current.lastLoginAt | dateToMoment }}
            </span>
          }
        </div>
      }

      <button
        type="button"
        role="menuitem"
        class="ks-btn ks-btn--glass ks-btn--block profile__signout"
        [disabled]="signingOut()"
        (click)="signOut()">
        <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
        <span>{{ signingOut() ? 'Cerrando sesión…' : 'Cerrar sesión' }}</span>
      </button>
    </div>
  }
</div>
